import connectLabels from "../utils/connectLabels";
import domWrap from "../utils/domWrap";
import h from "../utils/htm";
import RangeTouch from 'rangetouch';

export default async form => { // 'form[type*="Calc"]'
	(({
		PaymentCalc,
		CNGCalc,
		LNGCalc
	})[form.getAttribute('type')] || (() => {}))(form,RangeTouch);
};

function PaymentCalc(form){
	const 	float = getNumber(false),
			int = getNumber(true),
			reducer = valueReducer(form);

	prevent(form);

	domWrap(form).on('keydown','input',function(e){
		if([188].indexOf(e.which) !== -1){
			e.preventDefault();
		}
	})
	.on('keyup','input',form.getAttribute('id') === 'payment-calc' ? function(){
		const values = [
				['calc2_TruckPrice',false,float],
				['calc2_FinancePeriod',false,int],
				['calc2_InterestRate',false,v => v / 1200],
				['calc2_SalesTax',0,float],
				['calc2_DownPayment',0,float]
			].reduce(reducer,{}),
			truckPrice = (values['calc2_SalesTax'] > 0 ? values['calc2_TruckPrice'] * (1 + values['calc2_SalesTax'] / 100) : values['calc2_TruckPrice']) - values['calc2_DownPayment'],
			result = truckPrice * values['calc2_InterestRate'] / (1 - (Math.pow(1 / (1 + values['calc2_InterestRate']), values['calc2_FinancePeriod'])));
		
		form.querySelector('.result').innerHTML = (isNaN(result) || !isFinite(result) || values.incomplete ? 'Incomplete Data' : function(){
			return currency(result);
		}());
	} : function(){
		const values = [
				['monthlyPayment',false,float],
				['loanLength',false,int],
				['interestRate',false,v => v / 1200],
				['salesTax',0,float],
				['downPayment',0,float]
			].reduce(reducer,{}),
			totalAmount = values['monthlyPayment'] / (values['interestRate'] / (1 - (Math.pow(1 / (1 + values['interestRate']), values['loanLength'])))),
			subTotal = totalAmount + values['downPayment'],
			result = values['salesTax'] > 0 ? subTotal / (1 + values['salesTax'] / 100) : subTotal;

		form.querySelector('.result').innerHTML = (isNaN(result) || !isFinite(result) || values.incomplete ? 'Incomplete Data' : function(){
			return currency(result);
		}());
	});
}

function CNGCalc(form,RangeTouch){
	prevent(form);
	connectLabels(form);

	[...form.querySelectorAll('input[type="range"]')].forEach(input => new RangeTouch(input,{}));
	

	function calc(){
		var fields = [
			'fleet_size',
			'avg_mpy',
			'avg_diesel_mpg',
			'diesel_cost',
			'natural_gas_cost',
			'inc_ng_truck_cost',
			'gov_incentives'
		].reduce((obj,name) => {
			obj[name] = {
				val: getVal(form,name)
			}
			setResult(getChild(form,'[name="'+name+'"]'));
			return obj;
		},{});



		function val(name){
			return fields[name].val;
		}

		var gallons_used_diesel_total = (val('avg_mpy') * val('fleet_size')) / val('avg_diesel_mpg')
		var gallons_used_diesel_price = (val('avg_mpy') * val('fleet_size')) / val('avg_diesel_mpg') * val('diesel_cost');

		var gallons_used_ng_total = (val('fleet_size') * val('avg_mpy')) / (val('avg_diesel_mpg') * 0.9);
		var gallons_used_ng_price = (val('fleet_size') * val('avg_mpy')) / (val('avg_diesel_mpg') * 0.9) * (val('natural_gas_cost') * 1.13);

		var savings = gallons_used_diesel_price - gallons_used_ng_price;

		// done with calculations, apply rounding and formatting
		getChild(form,'[field="gallons_used_diesel_total"]').text(numberWithCommas(Math.round(gallons_used_diesel_total)));
		getChild(form,'[field="gallons_used_diesel_price"]').text(numberWithCommas(Math.round(gallons_used_diesel_price).toFixed()));

		getChild(form,'[field="gallons_used_ng_total"]').text(numberWithCommas(Math.round(gallons_used_ng_total)));
		getChild(form,'[field="gallons_used_ng_price"]').text(numberWithCommas(Math.round(gallons_used_ng_price).toFixed()));

		getChild(form,'[field="savings"]').html(numberWithCommas(savings.toFixed()));

		getChild(form,'[field="payback"]').html((((val('inc_ng_truck_cost') - val('gov_incentives')) * val('fleet_size')) / savings).toFixed(2));
		
	}

	[...form.querySelectorAll('input')].forEach(input => {
		input.addEventListener('change',calc);
		input.addEventListener('input',calc);
	});

	calc();
}

function LNGCalc(form,RangeTouch){
	prevent(form);
	connectLabels(form);
	[...form.querySelectorAll('input[type="range"]')].forEach(input => new RangeTouch(input,{}));
	

	function calc(){
		var fields = [
			'fleet_size',
			'avg_mpy',
			'avg_diesel_mpg',
			'diesel_cost',
			'natural_gas_cost',
			'inc_ng_truck_cost',
			'gov_incentives'
		].reduce((obj,name) => {
			obj[name] = {
				val: getVal(form,name)
			}
			setResult(getChild(form,'[name="'+name+'"]'));
			return obj;
		},{});

		function val(name){
			return fields[name].val;
		}

		var gallons_used_diesel_total = (val('avg_mpy') * val('fleet_size')) / val('avg_diesel_mpg')
		var gallons_used_diesel_price = (val('avg_mpy') * val('fleet_size')) / val('avg_diesel_mpg') * val('diesel_cost');

		var gallons_used_ng_total = (val('fleet_size') * val('avg_mpy')) / (val('avg_diesel_mpg') * 0.9);
		var gallons_used_ng_price = (val('fleet_size') * val('avg_mpy')) / (val('avg_diesel_mpg') * 0.9) * val('natural_gas_cost');

		var savings = gallons_used_diesel_price - gallons_used_ng_price;


		// done with calculations, apply rounding and formatting
		getChild(form,'[field="gallons_used_diesel_total"]').text(numberWithCommas(Math.round(gallons_used_diesel_total)));
		getChild(form,'[field="gallons_used_diesel_price"]').text(numberWithCommas(Math.round(gallons_used_diesel_price).toFixed()));

		getChild(form,'[field="gallons_used_ng_total"]').text(numberWithCommas(Math.round(gallons_used_ng_total)));
		getChild(form,'[field="gallons_used_ng_price"]').text(numberWithCommas(Math.round(gallons_used_ng_price).toFixed()));

		getChild(form,'[field="savings"]').html(numberWithCommas(savings.toFixed()));

		getChild(form,'[field="payback"]').html((((val('inc_ng_truck_cost') - val('gov_incentives')) * val('fleet_size')) / savings).toFixed(2));

	}

	[...form.querySelectorAll('input')].forEach(input => {
		input.addEventListener('change',calc);
		input.addEventListener('input',calc);
	});

	calc();
}

function valueReducer(form){
	return (obj,[key,def,fn]) => {
		const val = form.querySelector('#'+key)?.value || '';
		obj[key.toString()] = val.length > 0 ? (typeof fn === 'function' ? fn : () => false)(val) : def;
		if(obj[key.toString()] === false){
			obj.incomplete = true;
		}
		return obj;
	};
}

function getNumber(int){
	return (val) => {
		var cleanStr;
		if (typeof val === 'number') {
			return int ? parseInt(val.toString()) : val;
		}
		if(typeof val === 'string'){
			cleanStr = val.replace(/[^0-9$.]/g, '');
			return int ? parseInt(cleanStr) : parseFloat(cleanStr);
		}
		return 0;		
	}
}

function prevent(form){
	form.addEventListener('submit',e => e.preventDefault());
}

function currency(n,wrap){
	var num = numberWithCommas(Math.floor(Math.round(n*100)/100));
	return '$ '+ (wrap ? h(wrap,num) : num);
}

function numberWithCommas(n) {
	// format a decimal number to show commas 
	var parts=n.toString().split(".");
	return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
}

function getChild(parent,sel){
	const child = parent.querySelector(sel);
	child.text = (str) => child.textContent = str;
	child.html = (str) => child.innerHTML = str;
	return child;
}

function getVal(parent,name){
	return parent.querySelector('[name="'+name+'"]')?.value || '';
}

function setResult(input){
	var container = input.closest('div').querySelector('.result'),
		pre = container.getAttribute('prepend'),
		app = container.getAttribute('append'),
		plu = container.getAttribute('plural'),
		val = input.value;

	container.innerHTML = container.getAttribute('currency') === undefined ? 
		(pre ? pre + (parseFloat(val) === 1 ? '' : plu || '') : '')
		+ h('span',numberWithCommas(val)) +
		(app ? app + (parseFloat(val) === 1 ? '' : plu || '') : '')
	: currency(val,'span');
}